import { JsonObject, JsonProperty } from "typescript-json-serializer";
// *Geo.js Properties*
@JsonObject()
export class ProxyConfiguration {
    @JsonProperty()
    declare url: string;

    @JsonProperty()
    declare urlPrefixes: string[];

    constructor() {}
}
